// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__21wjq","item":"PaymentsMobile_item__2loLV","label":"PaymentsMobile_label__1s6SS","amount":"PaymentsMobile_amount__2_Pn4"};